import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSelectLassoDashed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="select-lasso-dashed, circle-to-search-dashed, encircle, mark"><path d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 4.29167 9.94444 5.31944 8.40278 9.94444" stroke="currentColor" strokeWidth="1.5" strokeDasharray="4 4"/></CentralIconBase>;
};

export default IconSelectLassoDashed;
